module.exports = __webpack_public_path__ + "img/glassthicknessminus-15.944a70ac.svg";